export default __webpack_public_path__ + "static/media/mastercard.1a1d2cb9.svg";